import IntlContainer from './IntlContainer';
export default IntlContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/index.js